<div *ngIf="isInitialized; else loading">
    <form [formGroup]="paymentTypesForm">
        <div class="card m-3">
            <div class="card-body">
                <h5 class="text-danger" *ngIf="!validatePaymentTypes() && showValidations" translate>promotion.noPaymentTypesValidation</h5>
                <div class="container" formArrayName="paymentTypes">
                    <div class="row">
                        <div class="col-6 col-md-4 col-lg-3" *ngFor="let pt of paymentTypesForms.controls; let i = index" [formGroupName]="i">
                            <input class="form-check-input" type="checkbox" formControlName="isSelected">
                            <label>{{pt.get('paymentType')?.value?.description}}</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>

<ng-template #loading>
    <div *ngIf="errorMessage$ | async as errorMessage; else spinner">
        <div class="alert alert-danger">
            {{errorMessage}}
        </div>
        <div class="d-flex justify-content-center">
            <i class="fa fa-refresh" (click)="reload()"></i>
        </div>
    </div>
    <ng-template #spinner>
        <div class="d-flex justify-content-center">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </ng-template>
</ng-template>
